// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"e4af46de","263":"54e13195","584":"8104a872"}[chunkId] + ".chunk.js";
};